import { render, staticRenderFns } from "./SocialIcons.vue?vue&type=template&id=0ccb3045&scoped=true&"
import script from "./SocialIcons.vue?vue&type=script&lang=js&"
export * from "./SocialIcons.vue?vue&type=script&lang=js&"
import style0 from "./SocialIcons.vue?vue&type=style&index=0&id=0ccb3045&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccb3045",
  null
  
)

export default component.exports